import { SetStateAction, useContext } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import cn from "classnames";

import { WizardButtons } from "shared/components/WizardNew/components/WizardButtons";
import { WizardData } from "shared/components/WizardNew/types";

import { SPLIT_TEST } from "shared/constants/split";
import { DEFAULT_MODE_WIZARD } from "shared/constants/wizard";

import { WizardStore, WizardType } from "shared/context/WizardStoreContext";

import { simplyClick } from "shared/helpers/analytics";
import { isSplitTestRequired } from "shared/helpers/view";
import { postWizardData, setStepperState } from "shared/helpers/wizard";

import { useWizard, WizardStep } from "shared/hooks/useWizard";

import styles from "@platformAssets/components/Wizard.module.scss";

type Props = { wizardData: WizardData };

const WizardWelcomeAddPhoto = ({ wizardData }: Props) => {
  const { t } = useTranslation("wizardNew");
  const [wizardState, setWizardStore] = useContext(WizardStore);

  const navigate = useNavigate();
  const wizard = useWizard(wizardData);
  const { mode } = wizardData;
  const isSplitReducedWizardEnabled =
    mode === DEFAULT_MODE_WIZARD &&
    isSplitTestRequired(wizard.data, SPLIT_TEST.reducedWizard);

  const step = wizard[WizardStep.WelcomeStep3];

  const handleClick = async () => {
    await postWizardData({}, WizardStep.WelcomeStep3);

    // Remove after refactoring helpers
    setWizardStore(
      setStepperState(
        wizardState,
        3,
        mode,
        isSplitReducedWizardEnabled
      ) as unknown as SetStateAction<WizardType>
    );

    step.analytics?.start?.forEach((item: string) => {
      simplyClick(item, null, false);
    });

    navigate(`/${step.nextStep}`);
  };

  return (
    <div className={styles.welcomeContainer}>
      <WizardButtons variant="welcome" showBack={false} userData={wizardData} />

      <div className={styles.welcome}>
        <div className={styles.wizardAnimationWrapper}>
          <div className={cn(styles.welcomeAnimation, styles.animation3)}>
            <div className={styles.row1} />
            <div className={styles.row2} />
            <div className={styles.row3} />
          </div>
        </div>

        <div className={styles.wizardInfoWrapper}>
          <div className={styles.welcomeTextWrapper}>
            <div>
              <div className={styles.welcomeTitle}>{t("block3.title")}</div>

              <div className={styles.welcomeDescription}>
                {t("block3.description")}
              </div>
            </div>
          </div>

          <div className={styles.btnWrap}>
            <button onClick={handleClick} className={styles.welcomeButton}>
              {t("block3.btn")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export { WizardWelcomeAddPhoto };
